import { useReducer, useState } from 'react';
import './App.scss';
import Login from './components/Login';
import { client } from './utils/graphQlSetup';
import MapList from './components/MapList';
import NavBar from './components/NavBar';
import { Button, ButtonGroup, Collapse, Form, ListGroup, Modal, Spinner, ToggleButton } from 'react-bootstrap';
import SearchableSelect from './components/SearchableSelect';
import { AnnotationComponent } from './components/Annotation';
import { hGetAnnotations } from './utils/hGetAnnotations';
import HypothesisLogo from './img/hypothesislogomark.png'
import GoogleLogo from './img/google-logo.svg'
import SlLogo from './img/SocietyLibraryLogo-WithTitle.png'
import { hGetGroups } from './utils/hGetGroups';
import Error from './components/Error';
import { AnnotationExtra } from './types/Annotations';
import { sendAnnotations } from './sendAnnotations';
import { decodeJwt } from 'jose';

const formatDateForInput = (date?: number) => {
  if (date === undefined) return undefined;
  const d = new Date(date);
  const offset = d.getTimezoneOffset()
  const date2 = new Date(d.getTime() - (offset * 60 * 1000))
  return date2.toISOString().split('Z')[0]
}

const localStorageId = 'h2dmap';
export const defaultDebateMap = {
  "id": "qJwAqTReRma_iVRvdu4Mng",
  "name": "[AI] AI Hackathon Map",
  "note": null,
  "rootNode": "mQdrcprqR-2uc2VRfJ4IJA",
  "accessPolicy": "4hlNGcf2RRCRuYv_1xZlhg",
  "nodeAccessPolicy": "4hlNGcf2RRCRuYv_1xZlhg",
  "__typename": "Map"
}

//const isPublic = document.location.toString().includes("sendto")

export interface AppState {
  hAccount?: string
  map: any
  hApiToken: string
  hGroups: any[]
  hGroup: any
  hAccoutType: "Public" | "Private"
  searchAfter: number
  tempSearchAfter?: string
  isAdvanced?: boolean
  lastGotAnnotations?: number
}

export type AppAction = Partial<AppState>

export function appReducer(state: Partial<AppState>, action: AppAction) {
  const appState = { ...state, ...action };
  localStorage.setItem(localStorageId, JSON.stringify(appState));
  return appState;
}

export function InitAppState() {
  let appState: Partial<AppState> = {}
  const localStorageString = localStorage.getItem(localStorageId);
  if (localStorageString) {
    try {
      appState = JSON.parse(localStorageString);
      // delete appState.lastGotAnnotations;
      // delete appState.searchAfter;
    } catch (error) {
      console.error(error)
    }
  }
  return appState;
}

export interface Account {
  account: string
  searchAfter?: number
}

export interface Group {
  groupId: string
  apiToken: string
  searchAfter?: number
}

const Hypothesis = <img src={HypothesisLogo} alt="Hypothes.is logo" className='m-2' style={{ height: ".5em", transform: 'scale(3) translatey(-8%)', padding: "0 2em" }} />
const Google = <img src={GoogleLogo} alt="Google logo" className='m-2' style={{ height: ".5em", transform: 'scale(3) translatey(-4%)', padding: "0 1.2em" }} />
const theSocietyLibrary = <img src={SlLogo} alt="Google logo" className='m-2' style={{ height: ".5em", transform: 'scale(5) translatey(0%)', padding: "0 .5em" }} />

let jwt = localStorage.getItem("jwt")
if (jwt) {
  const exp = decodeJwt(jwt)?.exp
  if (exp && exp < Date.now() / 1000) {
    localStorage.removeItem("jwt")
    jwt = null
  }
}

export default function App() {
  const [annotations, setAnnotations] = useState<AnnotationExtra[]>([])
  const [jwToken, setJwt] = useState(jwt)
  const [appState, dispatchState] = useReducer(appReducer, {}, InitAppState)
  const [devVisible, setDevVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSending, setisSending] = useState(false)
  const [showDone, setShowDone] = useState(false);
  const handleCloseDone = () => setShowDone(false);

  const statusTable = <table className="table" style={{ width: "unset" }}>
    <thead>
      <tr>
        <th>Pending</th>
        <th>Sent</th>
        <th>Errors</th>
        <th>Skip</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          {annotations.filter(a => a.state !== "Sent" &&
            a.state !== "Error" &&
            !a.skip
          ).length}
        </td>
        <td>
          {annotations.filter(a => a.state === "Sent").length}
        </td>
        <td>
          {annotations.filter(a => a.state === "Error").length}
        </td>
        <td>
          {annotations.filter(a => a.skip).length}
        </td>
      </tr>
    </tbody>
  </table>;

  const SendAnnotationsButton = <>
    {statusTable}
    <Button variant="primary"

      disabled={annotations.length < 1 || isSending}
      onClick={async () => {
        if (jwToken) {
          setisSending(true);
          await sendAnnotations(annotations, appState, setAnnotations, jwToken);
          setShowDone(true);
          if (appState.lastGotAnnotations) {
            dispatchState({ searchAfter: appState.lastGotAnnotations })
          }
          setisSending(false);
        }
      }}>
      {isSending && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        className='me-2'
      />}

      {isSending ? 'Sending' : 'Send'} Selected Annotations {isSending && '...'}
    </Button>
  </>

  return (<>
    <div className="App container auto ">
      <NavBar></NavBar>
      {!appState.isAdvanced &&
        <div>
          <b>To send claims to the Society Library you will need to :</b>
          <ul>
            <li>Install the <a href="https://web.hypothes.is/help/installing-the-chrome-extension/">{Hypothesis} browser extension</a> and create a Hypothesis ID</li>
            <li>Use the web extension to annotate claims on websites</li>
            {!jwToken ? <>
              <li>If you don't have a {Google} account, <a href="https://accounts.google.com/signup">create one</a>.</li>
              <li>Come back here and click the "<b>Log In</b>" button below and use a {Google} account</li>
              <li>Follow the instructions on the next screen to send those annotations to {theSocietyLibrary} the Society Library</li>
            </> :
              <li>Come back here and Follow the instructions on the next screen to send those annotations to {theSocietyLibrary} the Society Library</li>
            }
          </ul>
        </div>
      }
      {!jwToken ?
        <Login
          client={client}
          setJwt={setJwt}
        ></Login> :
        // <>----</>

        <Form>
          <div className="row">
            <div className="col-lg-6">
              {appState.isAdvanced &&
                <Form.Group className="mb-3" controlId="mapList">
                  <Form.Label>Select a Debate Map to send the annotations to</Form.Label>
                  <MapList id="formMapList"
                    client={client}
                    dispatch={dispatchState}
                    map={appState.map}
                  ></MapList>
                </Form.Group>
              }

              <Form.Group className="mb-3" controlId="mapList">
                <Form.Label>Which {Hypothesis} account do you want to pull the annotations from?
                </Form.Label>
                <ButtonGroup style={{ display: "block" }} className="mb-2">
                  <ToggleButton
                    id={"atPublic"}
                    type="radio"
                    variant="outline-primary"
                    name="radio"
                    value={"Public"}
                    checked={appState.hAccoutType === "Public"}
                    onChange={(e) => dispatchState({ hAccoutType: "Public" })}
                  >
                    Public Account
                  </ToggleButton>
                  <ToggleButton
                    id={"atPrivate"}
                    type="radio"
                    variant="outline-primary"
                    name="radio"
                    value={"Private"}
                    checked={appState.hAccoutType === "Private"}
                    onChange={(e) => {
                      dispatchState({ hAccoutType: "Private" })
                    }}
                  >
                    Private Group
                  </ToggleButton>
                </ButtonGroup>

              </Form.Group>

              {appState.hAccoutType === "Public" &&
                <Form.Group className="mb-3" controlId="formAccount">
                  <Form.Label>Enter the account you wish to read the annotations form</Form.Label>
                  <Form.Control className="w-30" type="input" placeholder="username@hypothes.is"
                    value={appState.hAccount || ''}
                    onChange={(e) => dispatchState({ hAccount: e.target.value })}
                  />
                </Form.Group>
              }

              {appState.hAccoutType === "Private" && <>

                <Form.Group className="mb-3" controlId="formApiToken">
                  <Form.Label>Hypothesis API Token</Form.Label>
                  <Form.Control type="password" placeholder="API Token"
                    value={appState.hApiToken || ''}
                    onChange={(e) => dispatchState({ hApiToken: e.target.value })}
                  />
                  <Form.Text >
                    Get your Hypothesis API token from <a target="_blank" href="https://hypothes.is/account/developer" rel="noreferrer">https://hypothes.is/account/developer</a>
                  </Form.Text>
                </Form.Group>

                {appState.hApiToken &&
                  <>
                    <div className="mb-3">
                      <Button variant="primary"
                        onClick={() => { hGetGroups(dispatchState, appState.hApiToken || '', setErrorMessage) }}>
                        {appState.hGroups ? "Refresh" : "Get"} Groups
                      </Button>
                    </div>

                    {appState.hGroups &&
                      <Form.Group className="mb-3" controlId="formHGroup">
                        <Form.Label>Hypothesis Group to pull annotations from </Form.Label>
                        <SearchableSelect
                          id={"formHGroup"}
                          type='single'
                          options={appState.hGroups}
                          optionlabel={'name'}
                          setSelected={(group) => { dispatchState({ hGroup: group }) }}
                          selected={appState.hGroup}
                          defaultIsOpen={false}
                        />
                      </Form.Group>
                    }
                  </>
                }
              </>}

              <Form.Group className="mb-3" controlId="formHGroup">
                <Form.Label>Only Annotations created after:</Form.Label>
                <Form.Control type="datetime-local"
                  value={
                    appState.tempSearchAfter ?
                      appState.tempSearchAfter :
                      formatDateForInput(appState.searchAfter) || ''}
                  onChange={(e) => {
                    try {
                      formatDateForInput(new Date(e.target.value).valueOf())
                      dispatchState({
                        searchAfter: new Date(e.target.value).valueOf(),
                        tempSearchAfter: undefined
                      })
                    } catch (error) {
                      dispatchState({
                        searchAfter: undefined,
                        tempSearchAfter: e.target.value
                      })
                    }

                  }}
                />
              </Form.Group>

              <div className="mb-3">
                <Button variant="primary"
                  disabled={!(appState.hAccoutType === "Private" && appState.hApiToken !== undefined) &&
                    !(appState.hAccoutType === "Public" && appState.hAccount !== undefined)}
                  onClick={() => {
                    if (appState.hAccoutType === "Private" &&
                      appState.hApiToken !== undefined) {
                      hGetAnnotations(setAnnotations, {
                        groupId: appState.hGroup.id,
                        apiToken: appState.hApiToken,
                        searchAfter: appState.searchAfter
                      }, setErrorMessage);
                    }

                    if (appState.hAccoutType === "Public"
                      && appState.hAccount !== undefined) {
                      hGetAnnotations(setAnnotations, {
                        account: appState.hAccount,
                        searchAfter: appState.searchAfter
                      }, setErrorMessage)
                    }

                    dispatchState({ lastGotAnnotations: new Date().valueOf() })
                  }}>
                  {annotations?.length ? "Refresh" : "Get"} Annotations
                </Button>
              </div>

            </div>
          </div>

          <div className="mb-3">
            <h2>Annotations</h2>

            {annotations.length > 0 && SendAnnotationsButton}

            <ListGroup>
              {annotations.map((annotation) =>
                AnnotationComponent({ annotation, setAnnotations })
              )}
            </ListGroup>
          </div>

          <div className="mb-3">
            {SendAnnotationsButton}
          </div>
        </Form>


      }

      {appState.isAdvanced && <>

        <Button
          variant={devVisible ? "primary" : "light"}
          onClick={() => setDevVisible(!devVisible)}
          aria-controls="developer-data"
          aria-expanded={devVisible}
          style={devVisible ? {} : { opacity: .2 }}
        >
          {devVisible ? "Hide" : "Show"} Dev Data
        </Button>
        <Collapse in={devVisible}>
          <div id="developer-data" style={{ border: "1px solid grey", borderRadius: ".5em", padding: ".5em" }}>
            <pre>{JSON.stringify(appState, undefined, 2)}</pre>
            <pre>{JSON.stringify(annotations, undefined, 2)}</pre>
          </div>
        </Collapse>
      </>
      }

      <Error errorMessage={errorMessage} setErrorMessage={setErrorMessage}></Error>

      <div style={{ opacity: .1, position: "fixed", bottom: "1em", right: "1em" }}
        onClick={(e) => dispatchState({ isAdvanced: appState.isAdvanced ? false : true })}
      >⚙️</div>
    </div>

    <Modal show={showDone} onHide={handleCloseDone}>
      <Modal.Header closeButton>
        <Modal.Title>Send Complete</Modal.Title>
      </Modal.Header>
      {statusTable}
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseDone}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>

  </>
  );
}



